import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import { getAllUsers } from './../../actions/users';
import Search from "@material-ui/icons/Search";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import customInputStyle from "assets/jss/material-dashboard-react/components/customInputStyle.js";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { Link, useHistory } from "react-router-dom";
import EditIcon from '@material-ui/icons/Edit';
import { acceptverification, rejectverification} from '../../actions/users';




import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';


// function createData(FirstName, lastName, Email, phoneNo, accountType) {
//   return { FirstName, lastName, Email, phoneNo, accountType };
// }

const rows = [
    // getData('')
    //   createData('firstName', 'lastName', 'Email', 'phoneNo', 'accountType')
    //   createData('Donut', 452, 25.0, 51, 4.9),
];


const headCells = [
    { id: 'FirstName', numeric: false, disablePadding: true, label: ' Name' },
    { id: 'email', numeric: true, disablePadding: false, label: 'Email' },
    { id: 'personalsite', numeric: true, disablePadding: false, label: 'Personal Site' },
    { id: 'bio', numeric: true, disablePadding: false, label: 'Bio' },
    { id: 'address', numeric: true, disablePadding: false, label: 'Address' },
    { id: 'action', numeric: true, disablePadding: false, label: 'Action' },
];

function EnhancedTableHead(props) {
    
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'center' : 'center'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 76%',
    },
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;

    return (
        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onChangeterm: PropTypes.func.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));


const customStyle = makeStyles(customInputStyle);

export default function EnhancedTable() {
    const classes = useStyles();
    const customStyles = customStyle();
    var [accverificationforcheckbox, setckeckboxvalueforaccver] = useState();
    const classesSearch = useToolbarStyles();
    const [data, setData] = React.useState(0);
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [userDetails, setUser] = useState();
    const [searchQuery, setSearchQuery] = React.useState("");
    const [typingTimeout, setTypingTimeout] = useState(0);
    const [open, setopen] = useState()
    const [close, setclose] = useState()
    var [selectedduerid,setselecteduserid]=useState()
    const [show12, setShow12] = useState(false);
 const handleClose12 = () => setShow12(false);
 const handleShow12 = () => setShow12(true)
    // const handleChange = event => {
    //     const { name, value } = event.target
    //     // getAll(setSearchTerm);
    // };



    const [opendl, setOpen] = React.useState(false);
  
    const handleClickToOpen = (e) => {
        setselecteduserid(e)
      setOpen(true);
    };
    
    const handleToClose = () => {
      setOpen(false);
    }
    function editR(id) 
    {
       // alert(e.target.id);
        if(id!='') {
            window.location="/useredit/"+id;
        }
        
    }
    function lock(){

    }
    async function accept(idd){
        console.log("==========================inside acccept")
      let reqData = {
        "id":idd
      }
      console.log(reqData);
      let result = await acceptverification(reqData);
      getAll()
    }

    async function reject(idd){
      let reqData = {
        "id":idd
      }
      console.log(reqData);
      let result = await rejectverification(reqData);
      getAll()
    }
    const handleChange = (event) => {
        const { name, value } = event.target;
        const self = this;
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        setSearchQuery(value)
        setTypingTimeout(setTimeout(function () {
            getAll({ 'search': value });
        }, 1000))
    }

    const handleRequestSort = (event, property) => {
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = rows.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };
    useEffect(() => {
        getAll();
    }, [])
    const getAll = async (search = {}) => {
        let filterData = search;
        if (filterData.search == '') {
            filterData = {}
        }
        var res = await getAllUsers(filterData);
        console.log('result', res.result);
        setUser(res.result.data);
        console.log('result of')
    }

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const isSelected = (name) => selected.indexOf(name) !== -1;

    // dialog
    const accstateupdate = (e) => {
        //setJson({'Gender':e.target.value})
        setckeckboxvalueforaccver(e.target.value)
       
        
    
      }
    

      //delete\
      const deleteuser=()=>{
         if(accverificationforcheckbox=='ver'){
            accept(selectedduerid)
            handleToClose()
            getAll();
         }else
            if(accverificationforcheckbox=='rej'){
                reject(selectedduerid)
                handleToClose()
                getAll();
            }else{
                getAll();
                handleToClose()
            }
         
      }

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <Toolbar
                    className={clsx(classesSearch.root, {
                        [classesSearch.highlight]: selected.length > 0,
                    })}
                >
                    <Typography className={classesSearch.title} variant="h6" id="tableTitle" component="div">
                        Users Details
                    </Typography>
                    <div className={classesSearch.searchWrapper}>
                        <FormControl
                            className={classesSearch.margin + " " + classesSearch.search + " " + customStyles.formControl}
                        >
                            
                        </FormControl>
                    </div>
                </Toolbar>
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        // size={dense ? 'small' : 'medium'}
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            numSelected={selected.length}
                            //   order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                        />
                        <TableBody>
                            {userDetails && userDetails .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {

                                // const labelId = `enhanced-table-checkbox-${index}`;
                                return (
                                    <TableRow>
                                        <TableCell align="center" component="th"

                                            // id={labelId}
                                            scope="row" padding="none">
                                            {row.name}
                                        </TableCell>
                                        <TableCell align="center">{row.email}</TableCell>
                                        <TableCell align="center">{row.personalsite}</TableCell>
                                        <TableCell align="center">{row.bio}</TableCell>
                                        <TableCell align="center">{row.curraddress}</TableCell>
                                        
                                        {row && row.Accountverified=="Pending" &&
                                          <TableCell align="center">{row.accountType}
                                          {/* <Link className={classes.btnPrimary} onClick={() => accept(row._id)}>Accept</Link> */}
                                          {/* <Button variant="contained" color="info"onClick={() => accept(row._id)}  >Accept</Button> */}

                                          <Button variant="contained" color="info"onClick={() => handleClickToOpen(row._id)}  >Pending</Button>
                                          <br></br>
                                          {/* <Link className={classes.btnPrimary} onClick={() => reject(row._id)}>Reject</Link> */}
                                          {/* <Button variant="contained" color="error"onClick={() => reject(row._id)}  >Reject</Button> */}

                                          </TableCell>
                                         }
                                         
                                          {row && row.Accountverified=="Rejected" &&
                                          <TableCell align="center">{row.accountType}
                                          {/* <Link className={classes.btnPrimary} >Rejected</Link> */}
                                          <Button variant="contained" color="error" >Rejected</Button>

                                          </TableCell>
                                         }
                                       
                                         {row && row.Accountverified=="Verified" &&
                                          <TableCell align="center">{row.accountType}
                                          {/* <Link className={classes.btnPrimary} >Verified</Link> */}
                                          <Button variant="contained" color="success" >Verified</Button>

                                          </TableCell>
                                         }
                                         {(row.Accountverified==undefined || row.Accountverified=="Not Verified") &&
                                          <TableCell align="center">{row.accountType}
                                          {/* <Link className={classes.btnPrimary}>Not Verified</Link> */}
                                          <Button variant="contained" color="warning"  >Not Verified</Button>

                                          </TableCell>
                                         }
                                    </TableRow>
                                );
                            })
                            }

                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={userDetails && userDetails.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Paper>



            <Dialog open={opendl} onClose={handleToClose}>
        <DialogTitle>{"Account Verificaton"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
           {/* {selectedduerid} */}
           
           <input type="radio" id="ver" name="accver" value="ver"   onChange={accstateupdate}></input>
              <label for="html">Verified</label>
              <input type="radio" id="rej" name="accver" value="rej"  onChange={accstateupdate}></input>
              <label for="css">Reject</label>

          </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button onClick={deleteuser} 
                  color="primary" autoFocus>
            Update
          </Button>
          <Button onClick={handleToClose} 
                  color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>

        </div>
    );
}